<template>
  <div class="server-wrap">
    <div class="nav-wrap" v-if="routerType !== 'main'">
      <div class="flex">
        <i class="iconfont icon-home1"></i>
        <router-link class="link" to="/publicity/main">信用公示</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" :to="$route.path" replace
        ><span>{{ routerTypeName }}</span></router-link
        >
      </div>
    </div>
    <div class="server-bottom">
      <div class="flex flex-wrap link-wrap" v-if="routerType === 'main'">
        <router-link
            tag="div"
            class="link-box"
            v-for="item in creditLink"
            :key="item.id"
            :to="item.link"
            :style="{ 'background-color': item.color }"
        >
          <div class="link-image flex flex-row-center">
            <img
                :src="item.image"
                :alt="item.title"
                srcset=""
                :style="{
                width: item.title === '信用修复公示' ? '100%' : 'auto',
                height: item.title === '信用修复公示' ? '100%' : 'auto',
              }"
            />
          </div>
          <div class="link-title">{{ item.title }}</div>
        </router-link>
      </div>
      <template v-else>
        <div class="server-title" v-if="routerTypeName">
          {{ routerTypeName }}
        </div>
        <!-- 红、黑名单 -->
        <!--        <div-->
        <!--          class="search-option flex"-->
        <!--          v-if="['honour', 'break'].includes(routerType)"-->
        <!--        >-->
        <div
            class="search-option flex"
            v-if="['honour', ].includes(routerType)"
        >
          <div class="position-button" @click="showHandler">
            {{ show ? '收起' : '高级筛选' }}
            <i class="el-icon-d-arrow-right"></i>
          </div>
        </div>
        <el-input
            class="server-search"
            v-model="serverWord"
            :placeholder="placeholder"
        >
          <el-select
              v-model="select"
              slot="prepend"
              placeholder="请选择"
              v-if="routerTypeName.includes[('司法判决', '信用评价')]"
              @change="selectHandler"
          >
            <template v-if="'信用目录公示' === routerTypeName">
              <el-option label="全部单位" :value="undefined"></el-option>
              <el-option
                  v-for="item in deptList"
                  :key="item.id"
                  :label="item.fullName"
                  :value="item.id"
              ></el-option>
            </template>
            <template v-else>
              <el-option label="法人及非法人组织" :value="1"></el-option>
              <el-option label="自然人" :value="2"></el-option>
            </template>
          </el-select>
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="creditSearchHandler"
          ></el-button>
        </el-input>
        <div class="server-condition" v-if="show">
          <div class="flex flex-items-start condition-bottom condition-middle">
            <div class="flex-shrink">当前选择</div>
            <div class="flex flex-wrap dept-wrap">
              <div
                  class="condition-dept condition-select"
                  v-if="currentMatter.id"
              >
                {{ currentMatter.title }}
                <i class="el-icon-close" @click="deleteDept"></i>
              </div>
            </div>
          </div>
          <div class="flex flex-items-start condition-bottom">
            <div class="flex-shrink">单位</div>
            <div class="flex flex-wrap dept-wrap">
              <div
                  class="condition-dept"
                  v-for="item in deptList"
                  :key="item.id"
                  :style="{ color: deptId === item.id ? '#d01c0b' : '' }"
                  @click="selectDept(item)"
              >
                {{ item.fullName }}
              </div>
            </div>
          </div>
          <div class="flex flex-items-start condition-bottom">
            <div class="flex-shrink">事项名称</div>
            <div class="flex flex-wrap dept-wrap">
              <div
                  class="condition-dept"
                  v-for="item in matterList"
                  :key="item.id"
                  :style="{
                  color: currentMatter.id === item.id ? '#d01c0b' : '',
                }"
                  @click="selectMatter(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <!-- Table -->
        <el-table :data="tableData" stripe @row-click="rowClick">
          <!--  -->
          <template v-if="routerType === 'honestMenu'">
            <el-table-column
                prop="date"
                label="提供单位"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="date"
                label="信用资源名称"
                align="center"
                width="150"
            ></el-table-column>
            <el-table-column
                prop="date"
                label="资源范围"
                align="center"
                width="100"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="是否对社会公开"
                align="center"
                width="150"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="共享条件"
                align="center"
                width="150"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="数据量"
                align="center"
                width="150"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="更新日期"
                align="center"
                width="100"
            ></el-table-column>
          </template>
          <!-- 行政裁决 -->
          <template v-else-if="routerType === 'adju'">
            <el-table-column
                prop="xzxdrmc"
                label="主体名称"
                align="center"
                width="350"
            ></el-table-column>
            <el-table-column
                prop="cjsy"
                label="裁决事由"
                align="center"
                width="300"
            ></el-table-column>
            <el-table-column
                prop="cjjgmc"
                label="单位名称"
                align="center"
                width="150"
            ></el-table-column>
            <el-table-column
                prop="cjjgmc"
                label="操作"
                align="center"
                width="190"
            >
              <template slot-scope="scope">
                <router-link
                    tag="a"
                    target="_blank"
                    style="color: #d01c0b"
                    :to="`/adjuDetail?detailInfo=${JSON.stringify(scope.row)}`"
                >查看详情
                </router-link>
              </template>
            </el-table-column>
          </template>
          <!-- 司法判决 -->
          <template v-else-if="routerType === 'courtDecision'">
            <el-table-column
                prop="name"
                label="主体名称"
                align="center"
                width="350"
            ></el-table-column>
            <el-table-column
                prop="caseCause"
                label="案由"
                align="center"
                width="300"
            ></el-table-column>
            <el-table-column
                prop="caseUnit"
                label="审理法院"
                align="center"
                width="150"
            ></el-table-column>
            <el-table-column
                prop="cjjgmc"
                label="操作"
                align="center"
                width="190"
            >
              <template slot-scope="scope">
                <router-link
                    tag="a"
                    target="_blank"
                    style="color: #d01c0b"
                    :to="`/creditCourtDecisionDetail?detailInfo=${JSON.stringify(
                    scope.row
                  )}`"
                >查看详情
                </router-link>
              </template>
            </el-table-column>
          </template>
          <!-- 信用评价 -->
          <template v-else-if="routerType === 'creditLevel'">
            <el-table-column
                prop="name"
                label="企业名称"
                align="center"
                width="300"
            ></el-table-column>
            <el-table-column
                prop="realname"
                label="法人姓名"
                align="center"
                width="200"
            ></el-table-column>
            <!-- 字段待添加 -->
            <el-table-column
                prop="number"
                label="统一社会信用代码"
                align="center"
                width="300"
            ></el-table-column>
            <el-table-column
                prop="scoreLevel"
                label="评价等级"
                align="center"
                width="195"
            ></el-table-column>
            <!-- <el-table-column prop="cjjgmc" label="操作" align="center" width="190">
                            <template slot-scope="scope">
                                <router-link tag="a" target="_blank" style="color: #d01c0b" :to="`/creditCourtDecisionDetail?detailInfo=${JSON.stringify(scope.row)}`">查看详情
                                </router-link>
                            </template>
                        </el-table-column> -->
          </template>
          <template v-else-if="routerType === 'break'">
            <el-table-column
                prop="name"
                label="被执行人名称"
                align="center"
                width="300"
            ></el-table-column>
            <el-table-column
                prop="executioncourt"
                label="执行法院"
                align="center"
                width="200"
            ></el-table-column>
            <!-- 字段待添加 -->
            <el-table-column
                prop="executioncaseno"
                label="执行依据文号"
                align="center"
                width="300"
            ></el-table-column>
            <el-table-column
                prop="casetime"
                label="发布时间"
                align="center"
                width="195"
            ></el-table-column>
            <!-- <el-table-column prop="cjjgmc" label="操作" align="center" width="190">
                            <template slot-scope="scope">
                                <router-link tag="a" target="_blank" style="color: #d01c0b" :to="`/creditCourtDecisionDetail?detailInfo=${JSON.stringify(scope.row)}`">查看详情
                                </router-link>
                            </template>
                        </el-table-column> -->
          </template>
          <template v-else-if="routerType === 'schoolcafeteriacreditrating'">
            <el-table-column
                prop="name"
                label="名称"
                align="center"
                width="340"
            ></el-table-column>
            <el-table-column
                prop="district"
                label="辖区"
                align="center"
                width="340"
            ></el-table-column>
            <el-table-column
                prop="scorelevel"
                label="信用等级"
                align="center"
                width="340"
            ></el-table-column>
          </template>
          <!-- else -->
          <template v-else>
            <el-table-column
                prop="realname"
                label="主体名称"
                align="center"
                width="384"
            >
              <template slot-scope="scope">
                {{
                  scope.row.type === '法人及非法人组织'
                      ? scope.row.name
                      : scope.row.realname
                }}
              </template>
            </el-table-column>
            <el-table-column
                prop="matterId"
                label="事项名称"
                align="center"
                width="320"
            >
              <template slot-scope="scope">
                {{ getMatterName(scope.row.matterId) }}
              </template>
            </el-table-column>
            <el-table-column
                prop="source"
                label="单位名称"
                align="center"
                width="190"
            ></el-table-column>
            <el-table-column
                prop="grandtotal"
                :label="routerTypeName === '守信红名单' ? '守信次数' : '失信次数'"
                align="center"
            ></el-table-column>
          </template>
          <!--          学校食堂信用评级-->

        </el-table>
        <div class="table-empty" v-if="!tableData.length">
          <empty/>
        </div>
        <div class="flex flex-row-end pagination-wrap" v-if="tableData.length">
          <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {PUBLICITYTTYPE} from '@/utils/creditServer'

import {
  adjuList,
  blackList,
  courtDecisionList,
  creditLevelList,
  getMatters,
  getOrganization,
  redList,
  schoolcafeteriacreditratingList,
} from '@/api'
import empty from '@/components/empty'

export default {
  components: {
    empty,
  },
  data() {
    return {
      serverWord: undefined,
      select: 1,
      creditLink: PUBLICITYTTYPE,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      deptList: [],
      deptId: undefined,
      deptSelectList: [],
      matterList: [],
      currentMatter: {},
      routerType: 'main',
      show: false,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    creditSearchHandler() {
      this.getList()
    },
    handleCurrentChange(e) {
      this.getData(e)
    },
    getData(page = 1) {
      if (
          ['honour', 'break', 'adju', 'courtDecision', 'creditLevel', 'schoolcafeteriacreditrating'].includes(
              this.routerType
          )
      ) {
        this.getList(page)
      }
    },
    getMatterName(id) {
      const data = this.matterList.filter((item) => item.id == id)
      if (data.length > 0) {
        return data[0].title
      }
      return ''
    },
    getMatters() {
      const data = {category: this.routerType === 'honour' ? 1 : 2}
      getMatters(data).then((res) => {
        this.$set(this, 'matterList', res)
      })
    },

    getEvaluation(page = 1) {
      this.creditLevelList()
    },

    getList(page = 1) {
      this.getMatters()
      const params = {
        type: this.select === 1 ? '法人及非法人组织' : '自然人',
        page,
      }
      if (this.currentMatter.id) {
        params.matterId = this.currentMatter.id
      }
      if (this.serverWord) {
        params.keyword = this.serverWord
      }


      if (this.routerType === 'creditLevel') {
        const p = {
          name: this.serverWord,
          current: page,
        }
        creditLevelList(p).then((res) => {
          const {records, size, total} = res
          this.$set(this, 'tableData', records)
          this.$set(this, 'total', total)
          this.$set(this, 'pageSize', size)
        })
      } else if (this.routerType === 'schoolcafeteriacreditrating') {
        const p = {
          name: this.serverWord,
          current: page,
        }
        schoolcafeteriacreditratingList(p).then((res) => {
          const {records, size, total} = res
          this.$set(this, 'tableData', records)
          this.$set(this, 'total', total)
          this.$set(this, 'pageSize', size)
        })

      } else {
        // 添加评价等级的查询
        ;(this.routerType === 'honour'
            ? redList
            : this.routerType === 'adju'
                ? adjuList
                : this.routerType === 'courtDecision'
                    ? courtDecisionList
                    : blackList)(params).then((res) => {
          const {records, size, total} = res
          this.$set(this, 'tableData', records)
          this.$set(this, 'total', total)
          this.$set(this, 'pageSize', size)
        })
      }
    },
    resetHandler() {
      this.$set(this, 'tableData', [])
      this.$set(this, 'total', 0)
      this.$set(this, 'pageSize', 15)
    },
    getDeptList() {
      getOrganization().then((res) => {
        this.$set(this, 'deptList', res)
      })
    },
    selectHandler(e) {
      // 【修改点 2】：去掉 this.getData()，改为清空旧数据
      this.tableData = []
      this.total = 0
    },
    // 收起，展开
    showHandler() {
      this.show = !this.show
      if (this.deptList.length === 0) {
        this.getDeptList()
      }
    },
    // 选择单位
    selectDept(row) {
      const {id} = row
      if (id !== this.deptId) {
        this.$set(this, 'deptId', id)
      }
    },
    selectMatter(row) {
      const {id} = row
      if (id !== this.currentMatter.id) {
        this.$set(this, 'currentMatter', row)
      }
      this.getList(1)
    },
    deleteDept() {
      this.$set(this, 'currentMatter', {})
    },
    rowClick(row) {
      const {number, realname, type} = row
      const queryParams = {
        tab: this.routerTypeName,
        number,
      }
      if (type === '自然人') {
        queryParams.name = realname
      }
      this.$router.push({
        name: 'company',
        query: queryParams,
      })
    },
  },
  beforeDestroy() {
    this.resetHandler()
  },
  computed: {
    routerTypeName() {
      this.resetHandler()
      if (this.routerType === 'main') {
        return ''
      } else {
        const type = this.routerType
        if (type === 'honour') {
          return '守信红名单'
        } else if (type === 'break') {
          return '失信黑名单'
        } else if (type === 'honestMenu') {
          return '信用目录公示'
        } else if (type === 'adju') {
          return '行政裁决'
        } else if (type === 'courtDecision') {
          return '司法判决'
        } else if (type === 'creditLevel') {
          return '信用评价'
        } else if (type === 'schoolcafeteriacreditrating') {
          return '学校食堂信用评级'
        } else {
          return ''
        }
      }
    },
    placeholder() {
      if (this.routerType === 'honestMenu') {
        return '请输入信用资源名称'
      }
      if (this.select === 1) {
        return '请输入主体名称 / 企业代码'
      } else {
        return '请输入主体名称 / 身份证号码'
      }
    },
  },
  watch: {
    $route: {
      handler(v) {
        const {
          params: {type},
        } = v
        this.$set(this, 'deptId', undefined)
        this.$set(this, 'currentMatter', {})
        this.$set(this, 'show', false)
        this.$set(this, 'routerType', type)
        if (type === 'honestMenu') {
          // 需要查单位
          this.$set(this, 'select', undefined)
          this.getDeptList()
        }
// 【修改点 1】：去掉 this.getData()，改为清空数据，等待用户手动点击查询
        this.tableData = []
        this.total = 0
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss">
.server-wrap {
  .server-bottom {
    position: relative;
    width: 1280px;
    margin: 0 auto;
    padding: 15px 0 30px;
    text-align: center;

    .el-table__header-wrapper {
      th {
        background-color: #f4f4f4;
        color: #212121;
      }
    }

    .el-table__empty-block {
      display: none;
    }

    .table-empty {
      margin: 0 auto;
      width: 995px;
    }

    .search-option {
      position: absolute;
      right: 250px;
      top: 160px;

      .position-button {
        cursor: pointer;
        color: $red;
        text-decoration: underline;

        & + .position-button {
          margin-left: 20px;
        }
      }
    }

    .server-condition {
      width: 995px;
      margin: 20px auto;
      background-color: #fff;
      padding: 20px;

      .flex-shrink {
        color: #aaa;
      }

      .condition-top {
        padding-left: 60px;

        .flex-shrink {
          margin-right: 20px;
        }

        .condition-button {
          flex-grow: 2;
          text-align: right;
          margin-left: 20px;

          & > .el-button {
            background-color: $red;
            border-color: $red;
          }
        }
      }

      .condition-bottom {
        padding: 15px 60px 35px;

        .dept-wrap {
          & > .condition-dept {
            width: 200px;
            line-height: 30px;
            padding: 4px;
            text-align: center;
            cursor: pointer;
          }
        }
      }

      .condition-middle {
        border-bottom: 2px solid #545454;
        padding-bottom: 10px;

        .dept-wrap {
          & > .condition-dept {
            width: auto;
            color: #d01c0b;
            border: 1px solid #d01c0b;
            border-radius: 4px;
            text-align: center;
            margin: 0 15px 15px;
          }
        }
      }
    }
  }

  .server-title {
    padding-top: 50px;
    line-height: 64px;
    font-size: 18px;
    color: $red;
    text-align: center;
    font-weight: bold;
  }

  .link-wrap {
    padding-top: 70px;

    .link-box {
      flex-basis: 23.5%;
      border-radius: 6px;
      margin-bottom: 60px;
      overflow: hidden;
      cursor: pointer;
      margin-right: 2%;

      &:nth-child(4n) {
        margin: 0 0 60px;
      }

      .link-image {
        height: 180px;
        opacity: 0.5;
      }

      .link-title {
        height: 50px;
        font-size: 16px;
        text-align: center;
        word-break: keep-all;
        z-index: 9;
        line-height: 50px;
        background-color: #eee;
        color: #333;
        font-weight: 700;
      }

      &:hover {
        .link-image {
          opacity: 1;
        }
      }
    }
  }

  .server-search {
    width: 590px;

    .el-input-group__prepend {
      padding: 0 15px;
      width: 25%;
      flex-shrink: 0;
      border: 1px solid $red;
      border-right: none;
      background-color: #fff;

      .el-select {
        width: 100%;

        .el-input {
          width: 100%;
        }
      }
    }
  }

  .el-table,
  .pagination-wrap {
    margin: 40px auto 0;
    width: 995px;
  }

  .el-table__cell {
    // line-height: 55px;
    .cell {
      line-height: 40px;
    }
  }
}
</style>
